module.exports = __webpack_public_path__ + "media/images/article/2022_01_b-8d6ef71b63cbe4e9a01e71aae93215a8.png";